import React from 'react'
import { useSelector } from 'react-redux'
import Selector from './components/Selector'

const RenderSelector = () => {
  const { questions } = useSelector((state) => state.models)

  return (
    questions < 5 && (
      <>
        <Selector />
      </>
    )
  )
}

export default RenderSelector
